<template>
  <div class="basic-info-wrapper">
    <div class="title">基本信息</div>
    <el-form-item label="药品条形码" prop="barcode">
      <el-input class="controller" v-model="barcode" placeholder="请输入（支持条码枪）" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item prop="name">
      <template #label>
        <form-label align="left" required>药品通用名</form-label>
      </template>
      <el-select
        class="controller lg"
        popper-class="select-drugsManagement"
        v-model="name"
        filterable
        placeholder="请输入"
        remote
        :remote-method="querySearch"
        :disabled="mode !== 'add'"
        clearable
      >
        <el-option
          v-for="drug in drugs"
          :key="drug.id"
          :label="`${drug.name}${drug.forbiddenMsg ? '（' + drug.forbiddenMsg + '）' : ''}`"
          :disabled="!!drug.forbiddenMsg"
          :value="`${drug.id},${drug.name},${drug.drugUsage || ''}`"
        ></el-option>
        <div class="empty" slot="empty">
          {{ loading ? '加载中...' : '抱歉，暂未匹配到该药品，紧急添加药品请拨打客服电话400-921-6690，感谢您的理解' }}
        </div>
      </el-select>
    </el-form-item>
    <el-form-item prop="spec">
      <template #label>
        <form-label align="left" required>药品规格</form-label>
      </template>
      <el-input
        class="controller lg"
        v-model="spec"
        placeholder="示例(0.25g*50粒，0.25g*8片*2板，6g*10袋，3ml:300iu)"
        :disabled="disabled"
      ></el-input>
      <el-popover
        placement="top"
        width="240"
        trigger="hover"
        content="规格一般格式为：数字+单位*数字+单位...，数字+单位为最小单元，中间用*：等符号隔开。"
      >
        <i slot="reference" size="28" class="el-icon-question spec-icon"></i>
      </el-popover>
    </el-form-item>
    <el-form-item label="生产厂家" prop="enterprise">
      <el-input class="controller lg" v-model="enterprise" placeholder="请输入" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="国药准字" prop="approvalNumber">
      <el-input class="controller" v-model="approvalNumber" placeholder="请输入" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="包装单位" prop="unit">
      <template #label>
        <form-label align="left" required>包装单位</form-label>
      </template>
      <el-select class="controller" v-model="unit" placeholder="请选择" :disabled="disabled">
        <el-option v-for="unit in units" :key="unit.value" :label="unit.label" :value="unit.value"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="drugUsage">
      <template #label>
        <form-label align="left">用法</form-label>
      </template>
      <el-input class="controller" :value="drugUsage" placeholder="请选择" disabled></el-input>
    </el-form-item>
  </div>
</template>

<script>
import Fetch from '@/api';
import formLabel from '@/components/global/form/label';
import drugSpecExample from '@/components/drugSpecExample.vue';

export default {
  name: 'basicInfo',
  components: {
    formLabel,
    drugSpecExample
  },
  props: {
    basicInfo: {
      type: Object
    },
    drugUsages: {
      type: Array
    },
    units: {
      type: Array
    },
    mode: {
      type: String
    }
  },
  data() {
    return {
      drugs: [],
      loading: false
    };
  },
  computed: {
    disabled() {
      return this.mode === 'view';
    },
    barcode: {
      get() {
        return this.basicInfo.barcode;
      },
      set(val) {
        this.$emit('change', 'barcode', val);
      }
    },
    name: {
      get() {
        return this.basicInfo.name;
      },
      set(val) {
        const [id, name, usage] = val.split(',');
        this.$emit('change', 'drugId', id);
        this.$emit('change', 'name', name);
        this.$emit('change', 'drugUsage', usage);
      }
    },
    spec: {
      get() {
        return this.basicInfo.spec;
      },
      set(val) {
        this.$emit('change', 'spec', val);
      }
    },
    enterprise: {
      get() {
        return this.basicInfo.enterprise;
      },
      set(val) {
        this.$emit('change', 'enterprise', val);
      }
    },
    approvalNumber: {
      get() {
        return this.basicInfo.approvalNumber;
      },
      set(val) {
        this.$emit('change', 'approvalNumber', val);
      }
    },
    unit: {
      get() {
        return this.basicInfo.unit;
      },
      set(val) {
        this.$emit('change', 'unit', val);
      }
    },
    drugUsage: {
      get() {
        return this.basicInfo.drugUsage;
      },
      set(val) {
        this.$emit('change', 'drugUsage', val);
      }
    }
  },
  methods: {
    querySearch(queryString) {
      if (queryString.length > 1) {
        this.loading = true;
        return Fetch.query_gnu_by_name({ name: queryString.trimStart().trimEnd() }).then(data => {
          this.loading = false;
          if (data) {
            this.drugs = data;
          } else {
            this.drugs = [];
          }
        });
      } else {
        this.drugs = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-info-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 28px;

  .title {
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: bold;
    color: #242424;
  }

  .controller {
    width: 176px;

    &.lg {
      width: 483px;
    }
  }
}
</style>

<style lang="scss">
.select-drugsManagement {
  .empty {
    padding: 14px 12px;
    width: 483px;
    font-size: 14px;
    color: #242424;
    word-break: break-all;
  }
}
.spec-icon {
  color: #bfbfbf;
  font-size: 16px;
  margin-left: 4px;
}
</style>
